<script setup lang="ts">
import { Button, Hero, Icon } from "@/components/Ui";
import { onDashboard, onEvent, onLink } from "@/helpers/events";

interface Props {
  data: {
    locale_title: {
      [key: string]: string;
    } | null,
    locale_subtitle: {
      [key: string]: string;
    } | null,
    locale_button: {
      [key: string]: string;
    } | null,
    button_link: {
      [key: string]: string;
    } | null,
    svg_card: string | null;
    ItemsUTP: any[];
  };
  buttonEvent?: string;
}

const props = defineProps<Props>();
const {t, locale} = useI18n();
const localePath = useLocalePath();
const router = useRouter();

const hero = computed(() => {
  const buttonAction = async () => {
   const buttonEvent =  props.buttonEvent || 'create account started';

  if (props.data?.button_link?.includes("app.pst.net")) {
    await onDashboard(buttonEvent, props.data?.button_link.split("app.pst.net").pop(), {});
  } else if (props.data?.button_link?.includes("pst.net")) {
    await onEvent(buttonEvent, router.push(localePath(props.data?.button_link.split("pst.net").pop())), {});
  } else {
    await onLink(buttonEvent, props.data?.button_link, {}, false);
  }
};

  return {
    title: props.data.locale_title[locale.value] || props.data.locale_title.en,
    subtitle: props.data.locale_subtitle[locale.value] || props.data.locale_subtitle.en,
    buttonText: props.data.locale_button[locale.value] || props.data.locale_button.en || t('btn.issueCard'),
    buttonAction,
    card: props.data.svg_card,
    utp: props.data.ItemsUTP.map((item) => {
      return {
        value: item.value,
        title: item.locale_title[locale.value] || item.locale_title.en,
      }
    })
  }
});
</script>
<template>
  <Hero class="container">
    <div :class="$style.head">
      <h1 :class="`${$style[`title`]} ${
      $style[`title-${locale}`]
    }`">
        {{hero.title}}
      </h1>
      <p>
        {{hero.subtitle}}
      </p>
    </div>
    <ul
      v-if="hero.utp.length"
      :class="$style.tariff"
    >
      <li v-for="(item, index) in hero.utp" :key="index">
        <span>
          {{ item.value }}
        </span>
        <span>
          {{ item.title }}
        </span>
      </li>
    </ul>
    <div :class="$style[`card`]">
      <Icon
        v-if="!hero.card"
        name="pst-default"
        path="cards"
      />
      <span v-else v-html="hero.card" />
      <Button
        :title="hero.buttonText"
        :class="$style[`button`]"
        color="orange"
        size="custom"
        @click="hero.buttonAction()"
      />
    </div>
  </Hero>
</template>
<style lang="scss" module>
.head {
  @apply flex flex-col gap-[10px] text-center;

  & p {
    @apply text-[15px] text-neutral-700;
  }
}
.title {
  @apply mb-0 font-black leading-none;
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-bg,
  &-pt,
  &-ua,
  &-tr,
  &-zh,
  &-it,
  &-fr,
  &-es,
  &-de,
  &-ja,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw{
    @apply text-[40px];
  }
  &-ru {
    @apply text-[30px] xxs:text-[32px] 414:text-[40px];
  }
  &-ja,
  &-tr,
  &-zh {
    @apply leading-[1.2];
  }
}
.tariff {
  @apply flex flex-row flex-wrap gap-y-3 lg:gap-x-5 lg:w-fit lg:max-w-full;

  & > li {
    @apply flex flex-col w-1/3 lg:w-[140px] text-center;

    & span {
      &:first-child {
        @apply text-[25px] text-neutral-900;
      }

      &:last-child {
        @apply text-[12px] xxs:text-[14px] xs:text-[16px] text-neutral-700;
      }
    }
  }

  &-old {
    @apply hidden lg:inline-flex opacity-60 not-italic line-through px-2;
  }
}

.card {
  @apply flex flex-col items-center gap-[10px] w-full max-w-[336px];

  & svg {
    @apply h-full w-full;
  }
}

.button {
  @apply text-[15px] w-full h-12;
}
</style>
